module.exports = __webpack_public_path__ + "static/media/login_img2x.f8aed476.jpg";